export default __webpack_public_path__ + "static/soc-a4b113d8a56bf4c86689744249e83062.png";